import React from "react";

import MessageList from "./MessageList";
import VisitorSatisfaction from "./visitorSatisfaction";

import { useWebmessenger } from "../../utils/webmessenger";

const PoweredBy = React.lazy(() => import("../window/PoweredBy"));

function Conversation() {
    const { conversation, visitorSatisfactionIntegration } = useWebmessenger();

    return (
        <>
            <div className="ek-chat__conversation">
                <MessageList />
                <div className="ek-chat__conversation--mask" />
            </div>

            <PoweredBy className="ek-chat__by--conversation" />
            {conversation &&
                conversation.status === "closed" &&
                conversation.satisfactionRating === null &&
                !!visitorSatisfactionIntegration && <VisitorSatisfaction />}
        </>
    );
}

export default Conversation;
